export default __webpack_public_path__ + "static/media/file.e97bb703.png";